/**
 * 网诊订单模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取网诊订单列表
export const webChatList = (params) => {
  return req.get('/webchat/order/list', params);
}

// 获取网诊订单列表各状态数量
export const webChatNum = (params) => {
  return req.get('/webchat/order/webOrderNum', params);
}

// 新增网诊订单
export const webChatAdd = (params) => {
  return req.post('/webchat/order', params);
}

// 查看网诊订单详情
export const webChatDetails = (params) => {
  return req.get(`/webchat/order/detail`, params);
}

// 结束网诊
export const completeWebChat = (params) => {
  return req.post('/program/order/info/complete', params);
}

// 推送问诊单
export const sendIquiry = (params) => {
  return req.post('/webchat/inquiry/info/createAndSend', params);
}

// 查询问诊单详情
export const iquiryDetails = (id) => {
  return req.get(`/webchat/inquiry/info/${id}`);
}

//已读消息
export const chatPatientApi = (params) => {
  return req.get('/webchat/records/chatPatient',params);
}
//取消已读消息
export const delChatPatientApi = (params) => {
  return req.get('/webchat/records/delChatPatient',params);
}

//赠送网诊时长
export const sendGiftTimeApi=(params) => {
  return req.post('/webchat/order/giftTime',params);
}
//搜索聊天技术
export const searchChatRecordApi=(params) => {
  return req.get('/webchat/records/queryRecords',params);
}
//网诊退费
export const outPatientApi=(params) => {
  return req.post(`/program/pay/webchat/refund`, params);
}

//获取当前患者问诊单列表
export const getInquiryListApi=(params) => {
  return req.get('/webchat/inquiry/info/list',params);
}

// 切换在线状态
export const switchDoctorOnLine=(params) => {
  return req.post('/webchat/doctor/switchOnLine',params);
}

// 获取聊天记录
export const getWebchatRecords=(params) => {
  return req.get('/webchat/records/list', params);
}

// 聊天消息已读
export const setReadWebChatMsg=(params) => {
  return req.post('/webchat/records/readWebChatMsg', params);
}